<template>
  <div id="app">
    <v-app>
      <v-content>
        <CustomerVerification v-if="verifyUser" />
        <PrivacyAndPolicy v-else-if="privacyAndPolicy" />
        <template v-else>
          <template v-if="!logged_in">

            <staff-login
              v-if="adminLogin"
              :changeLogin="changeLogin"
            />

            <!-- customer registration -->
            <customer-registration
              v-else-if="showRegistration"
              @logged-in="handleLogin"
            />

            <!-- customer login -->
            <login-component
              v-else
              :changeLogin="changeLogin"
              :changePhoneLogin="changePhoneLogin"
            />

          </template>
          <page-container v-if="logged_in"></page-container>
        </template>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import loginComponent from './components/loginComponent.vue'
import customerRegistration from './components/customerRegistration.vue'
import staffLogin from './components/staffLogin.vue'
import pageContainer from './components/pageContainer.vue'
import axios from 'axios'
import swal from 'sweetalert'
import CustomerVerification from './components/customerVerification/CustomerVerification.vue'
import PrivacyAndPolicy from './PrivacyAndPolicy.vue'

export default {
  name: 'app',
  data() {
    return {
      logged_in: localStorage.getItem('logged_in'),
      url: 'api/login',
      userData: {},
      adminLogin: false,
      verifyUser: false,
      privacyAndPolicy: false,
      showRegistration: false
    }
  },

  mounted() {
    if (this.logged_in) {
      this.getUserPermissions(localStorage.getItem('access_token'))
      this.getSettings(localStorage.getItem('access_token'))
    }

    const path = this.$router.currentRoute.fullPath
    if (path === '/customer-verification') {
      this.verifyUser = true
    } else if (path === '/privacy-and-policy') {
      this.privacyAndPolicy = true
    } else if (path === '/customer-registration') {
      this.showRegistration = true
    } else if (path === '/shipzone-admin') {
      this.adminLogin = true
    } else if (path.startsWith('/driver-deliver')) {
      this.adminLogin = true
    }
  },

  watch: {
    $route() {
      const path = this.$router.currentRoute.fullPath

      this.verifyUser = path === '/customer-verification'
      this.privacyAndPolicy = path === '/privacy-and-policy'
      this.showRegistration = path === '/customer-registration'

      if (!this.logged_in && !this.verifyUser && !this.privacyAndPolicy && !this.showRegistration) {
        this.$router.push('login')
      }
    }
  },

  methods: {
    handleLogin(token) {
      localStorage.setItem('access_token', token)
      this.getUser(localStorage.getItem('access_token'))
      this.getUserPermissions(localStorage.getItem('access_token'))
      this.getSettings(localStorage.getItem('access_token'))
    },

    changeLogin(loginData) {
      axios
        .post(this.url, loginData)
        .then(response => {
          this.handleLogin(response.data.access_token)
        })
        .catch(error => {
          if (error.response) {
            swal('Error', `${error.response.data.message}`, 'error')
          }
        })
    },

    changePhoneLogin(form) {
      axios
        .post('api/phone-login', form)
        .then(response => {
          this.handleLogin(response.data.access_token)
        })
        .catch(error => {
          if (error.response) {
            swal('Error', `${error.response.data.message}`, 'error')
          }
        })
    },

    getUserPermissions(token) {
      axios
        .get('api/auth_user_permissions', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          localStorage.setItem('user_permissions', JSON.stringify(response.data))
        })
    },

    getSettings(token) {
      axios
        .get('api/settings', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          localStorage.setItem('app_settings', JSON.stringify(response.data.data))
        })
    },

    getUser(token) {
      axios
        .get('api/me', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          localStorage.setItem('user_data', JSON.stringify(response.data))
          this.userData = JSON.parse(localStorage.getItem('user_data'))
        })
        .then(() => {
          if (this.userData.is_staff) {
            this.checkExpiredCoupons()
            localStorage.setItem('logged_in', true)
            this.logged_in = localStorage.getItem('logged_in')
            localStorage.setItem('secret_key', false)
          } else {
            console.log('else')
            if (
              !this.userData.phone_number ||
              !this.userData.full_name ||
              !this.userData.email ||
              !this.userData.address
            ) {
              console.log('else -> if')
              localStorage.setItem('logged_in', true)
              this.logged_in = localStorage.getItem('logged_in')
              this.$router.push('/')
            } else {
              console.log('else -> else')
              localStorage.setItem('logged_in', true)
              this.logged_in = localStorage.getItem('logged_in')
              this.$router.push('/dashboard')
            }
          }
          setTimeout(function () {
            location.reload(true)
          }, 1)
        })
    },

    checkExpiredCoupons() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/check_expired_coupons', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => { })
    }
  },
  components: {
    'login-component': loginComponent,
    'page-container': pageContainer,
    'staff-login': staffLogin,
    'customer-registration': customerRegistration,
    CustomerVerification,
    PrivacyAndPolicy
  }
}
</script>
<style>
.ws-nowrap {
  white-space: nowrap !important;
}

/* Shared spacing for the Save/Submit button in the addEdit* modal pattern -- was a
   copy-pasted inline style="margin-right: 2%" across ~28 files, which the RTL build
   can't mirror (inline styles bypass the postcss-rtl pipeline). */
.submit-btn-spacing {
  margin-right: 2%;
}

.rtl-mr-1-5pct {
  margin-right: 1.5%;
}
.rtl-mr-2-5pct {
  margin-right: 2.5%;
}
.rtl-mr-3pct {
  margin-right: 3%;
}
.rtl-mr-4pct {
  margin-right: 4%;
}
.rtl-mr-5pct {
  margin-right: 5%;
}
.rtl-mr-6pct {
  margin-right: 6%;
}
.rtl-mr-7pct {
  margin-right: 7%;
}

/* Atomic RTL-mirrorable spacing utilities: replace one-off inline
   style="margin-right:Npx"/"padding-left:Npx" etc. across the order-list screens
   (which the RTL build can't mirror since it's inline) with a class the postcss-rtl
   build DOES mirror. Named after the CSS property + value they hold -- add more as
   needed, don't repurpose an existing one for a different value. */
.rtl-pl-0 { padding-left: 0px; }
.rtl-pl-3 { padding-left: 3px; }
.rtl-pl-5 { padding-left: 5px; }
.rtl-pl-6 { padding-left: 6px; }
.rtl-pl-10 { padding-left: 10px; }
.rtl-pl-8 { padding-left: 8px; }
.rtl-pl-15 { padding-left: 15px; }
.rtl-pl-20pct { padding-left: 20%; }
.rtl-pl-2pct { padding-left: 2%; }
.rtl-pr-0 { padding-right: 0px; }
.rtl-pr-3 { padding-right: 3px; }
.rtl-pr-5 { padding-right: 5px; }
.rtl-pr-10 { padding-right: 10px; }
.rtl-pr-15 { padding-right: 15px; }
.rtl-pr-30 { padding-right: 30px; }
.rtl-ml-2 { margin-left: 2px; }
.rtl-ml-4 { margin-left: 4px; }
.rtl-ml-5 { margin-left: 5px; }
.rtl-ml-6 { margin-left: 6px; }
.rtl-ml-8 { margin-left: 8px; }
.rtl-ml-10 { margin-left: 10px; }
.rtl-ml-15 { margin-left: 15px; }
.rtl-ml-20 { margin-left: 20px; }
.rtl-ml-25pct { margin-left: 25%; }
.rtl-mr-2 { margin-right: 2px; }
.rtl-mr-5 { margin-right: 5px; }
.rtl-mr-6 { margin-right: 6px; }
.rtl-mr-8 { margin-right: 8px; }
.rtl-mr-10 { margin-right: 10px; }
.rtl-mr-20 { margin-right: 20px; }
.rtl-mr-40 { margin-right: 40px; }
.rtl-mr-75 { margin-right: 75px; }
.rtl-mr-115 { margin-right: 115px; }
.rtl-ml-10 { margin-left: 10px; }
.rtl-ml-0-imp { margin-left: 0px !important; }
.rtl-pl-0-imp { padding-left: 0px !important; }
.rtl-pr-13 { padding-right: 13px; }
.rtl-float-left { float: left; }
.rtl-float-right { float: right; }

/* Shorthand padding whose 2nd/4th (right/left) values differ -- postcss-rtl only
   mirrors longhand padding-left/-right, not the shorthand form, so this pair is
   hand-authored rather than relying on the auto-mirror pipeline. */
.navbar-brand-padding {
  padding: 13px 0px 10px 20px;
}
[dir="rtl"] .navbar-brand-padding {
  padding: 13px 20px 10px 0px;
}

/* Directional glyphs (chevrons/angle icons whose LEFT/RIGHT meaning is semantic, e.g.
   "previous"/"next") need the icon itself mirrored, not just its spacing -- hand-authored
   rather than auto-mirrored, since transform isn't a property the RTL build pipeline
   touches. */
[dir="rtl"] .rtl-flip-icon {
  transform: scaleX(-1);
}

.hover-container {
  position: relative;
}

.hover-container:hover .hover-content {
  visibility: visible;
  opacity: 1;
}

.hover-content {
  visibility: hidden;
  opacity: 0;
  transition: all 0.3 linear;
  position: absolute;
  top: -10px;
  right: 130px;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 8px 16px;
  width: 310px;
}

.popover-arrow {
  position: absolute;
  top: 25px;
  right: -7px;
  z-index: 3000;
  height: 13px;
  width: 13px;
  border-radius: 0px;
  border: 1px solid #e4e7ed;
  background: #fff;
  transform: rotate(135deg);
  border-bottom: none;
  border-right: none;
}

.popover-arrow-left {
  position: absolute;
  top: 25px;
  left: -7px;
  z-index: 3000;
  height: 13px;
  width: 13px;
  border-radius: 0px;
  border: 1px solid #e4e7ed;
  background: #fff;
  transform: rotate(-45deg);
  border-bottom: none;
  border-right: none;
}

/* Print helpers */
.print-only { display: none !important; }
@media print {
  .no-print { display: none !important; }
  .print-only { display: block !important; }
  .panel.panel-flat { height: auto !important; overflow: visible !important; }
  .content-wrapper { margin: 0 !important; padding: 0 !important; }
}
</style>



// WEBPACK FOOTER //
// src/App.vue